module.exports = __webpack_public_path__ + "img/celebrate-img.8c0139b8.png";